<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "OsobaUmanjeniSatBase"
};
</script>

<style scoped>

</style>
